import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = { class: "text-xs" }

import { CircleAlert } from 'lucide-vue-next';
    import { HoverCardContent, HoverCardPortal, HoverCardRoot, HoverCardTrigger } from 'reka-ui';
    import { useI18n } from 'vue-i18n';
    import { formatDate, formatCurrency } from '@/utils/helpers';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeSalaryChangeRegistrated',
  props: {
    unnotedSalary: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(HoverCardRoot), {
    "close-delay": 0,
    "open-delay": 0
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(HoverCardTrigger), null, {
        default: _withCtx(() => [
          _createVNode(_unref(CircleAlert), { class: "text-warning size-4" })
        ]),
        _: 1
      }),
      _createVNode(_unref(HoverCardPortal), null, {
        default: _withCtx(() => [
          _createVNode(_unref(HoverCardContent), {
            class: "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 flex flex-col gap-1 rounded-xl border bg-white p-4 shadow-sm data-[state=open]:transition-all",
            "side-offset": 5
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(CircleAlert), { class: "text-secondary size-4" }),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('employee.changes.past_salary', {
                                amount: _unref(formatCurrency)(_ctx.unnotedSalary.amount),
                                date: _unref(formatDate)(_ctx.unnotedSalary.starts_at),
                            })), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})